<script setup lang="ts" generic="ListingFilter extends { code: string }">
import SwFilterPropertiesVue from "./SwFilterProperties.vue";
import SwFilterPriceVue from "./SwFilterPrice.vue";
import SwFilterRatingVue from "./SwFilterRating.vue";
import SwFilterShippingFreeVue from "./SwFilterShippingFree.vue";

const emit = defineEmits<{
  (e: "selectFilterValue", { code, value }: { code: any; value: any }): void;
}>();

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters?: {
    [key: string]: any;
  };
}>();

const cmsMap = () => {
  const map: {
    [key: string]: any;
  } = {
    properties: SwFilterPropertiesVue,
    price: SwFilterPriceVue,
    rating: SwFilterRatingVue,
    "shipping-free": SwFilterShippingFreeVue,
  };

  return map[props.filter?.code];
};
</script>
<template>
  <component
    :is="cmsMap()"
    :filter="filter"
    :selected-filters="selectedFilters"
    @select-value="emit('selectFilterValue', $event)"
  />
</template>
